import { render, staticRenderFns } from "./communityindex.vue?vue&type=template&id=bf441e32&scoped=true"
import script from "./communityindex.vue?vue&type=script&lang=js"
export * from "./communityindex.vue?vue&type=script&lang=js"
import style0 from "./communityindex.vue?vue&type=style&index=0&id=bf441e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf441e32",
  null
  
)

export default component.exports